import React from "react";
import PriorityLabel from "./PriorityLabel";
import { PRIORITY_TYPES } from "../../constants/priority";

export const TablePriorityLabel = ({ item }) => {
  const priority =
    PRIORITY_TYPES.find(({ id }) => id === item?.priority) || PRIORITY_TYPES[3];
  return <PriorityLabel {...priority} />;
};

export default TablePriorityLabel;
